<template>
  <div>
    <div class="l-row">
      <form-group label="Selecione uma variação para vincular ao anúncio" :columns="12" :required="true">
        <select class="form-select" v-model="sku" @change="changeVariation">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="variation in product.variations" :key="variation" :value="variation.sku">{{ variationTitle(variation) }}</option>
        </select>
      </form-group>
    </div>

    <panel title="Produto vínculado" class="blue-panel" v-if="productCatalog">
      <panel>
        <div class="product-catalog">
          <div class="img-container">
            <img :src="productCatalog.pictures[0].url">
          </div>

          <div class="title">
            {{ productCatalog.name }}
          </div>
        </div>
      </panel>
    </panel>

    <variation-attributes v-if="variation" :variation="variation" :fromModule="fromModule" :productId="product.productId"/>

    <div v-if="sku !== null" class="divider"><span>Atributos</span></div>

    <general-attributes v-if="variation" :product="variation" :attributes="category.variations_attributes" :typeCheckout="typeCheckout"/>

    <image-variation v-if="variation" :variation="variation"/>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import FormGroup from '@/components/template/FormGroup'
  import GeneralAttributes from '@/components/marketplace/mercadoLivre/announcement/general/Attributes'
  import VariationAttributes from '@/components/marketplace/mercadoLivre/announcement/variation/VariationAttributes'
  import ImageVariation from '@/components/marketplace/shared/provide/Image'
  import Panel from '@/components/template/Panel'

  export default {
    data: () => ({
      variation: null,
      sku: null,
      productCatalog: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      category: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      typeCheckout: {
        type: Boolean,
        required: true
      }
    },
    async mounted () {
      if (this.product.variations.length === 1) {
        this.sku = this.product.variations[0].sku
        this.changeVariation(this.product.variations[0])
      }
    },
    methods: {
      variationTitle (variation) {
        return variation.sku
      },
      changeVariation () {
        if (!this.sku) {
          this.variation = null
          return
        }

        this.variation = this.product.variations.find((variation) => variation.sku === this.sku)

        this.getProductCatalog()
      },
      async getProductCatalog () {
        this.productCatalog = null
        this.product.productCatalogId = null
        let variationEan = null

        if (this.variation.attributes['GTIN']) {
          variationEan = this.variation.attributes['GTIN']
        } else if (this.variation.ean) {
          variationEan = this.variation.ean
        }

        if (!variationEan) {
          notifier.warning('O produto não possui EAN, logo não pode ser usado o tipo checkout.', 'Produto sem EAN')
          this.emitChangeTypeCheckout(false)
          return
        }

        try {
          this.productCatalog = await api.mercadoLivre.getProductCatalog(variationEan)
          this.product.productCatalogId = this.productCatalog.id
        } catch (e) {
          notifier.warning('Nenhum produto foi encontrado no catálogo do Mercado Livre com esse EAN.', 'Produto não encontrado')
          this.emitChangeTypeCheckout(false)
        }
      },
      emitChangeTypeCheckout (v) {
        this.$emit('changeTypeCheckout', v)
      }
    },
    watch: {
      variation (variation) {
        if (!variation) {
          return false
        }

        const variationAttributes = this.category.variations_attributes

        for (let i in variationAttributes) {
          let attribute = variation.attributes[variationAttributes[i].id]

          if (attribute === undefined) {
            variation.attributes[variationAttributes[i].id] = null
          }

          if (variationAttributes[i].id === 'EAN' || variationAttributes[i].id === 'GTIN') {
            variation.attributes[variationAttributes[i].id] = variation.ean || null
          }

          if (variationAttributes[i].id === 'SKU' || variationAttributes[i].id === 'SELLER_SKU') {
            variation.attributes[variationAttributes[i].id] = variation.sku || null
          }

          if (variationAttributes[i].id === 'PACKAGE_HEIGHT') {
            variation.attributes[variationAttributes[i].id] = variation.height || null
          }

          if (variationAttributes[i].id === 'PACKAGE_LENGTH') {
            variation.attributes[variationAttributes[i].id] = variation.length || null
          }

          if (variationAttributes[i].id === 'PACKAGE_WIDTH') {
            variation.attributes[variationAttributes[i].id] = variation.width || null
          }

          if (variationAttributes[i].id === 'PACKAGE_WEIGHT') {
            variation.attributes[variationAttributes[i].id] = variation.weight || null
          }
        }

        this.product.variation = variation
      }
    },
    components: {
      FormGroup,
      GeneralAttributes,
      VariationAttributes,
      ImageVariation,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .product-catalog
    display: flex
    align-items: center

    .img-container
      display: flex
      justify-content: center
      align-items: center
      margin: 0 25px

      img
        max-width: 100%
        max-height: 75px

    .title
      font-size: 20px
</style>



// WEBPACK FOOTER //
// Single.vue?20f79650